module.exports = __webpack_public_path__ + "static/media/rocket.de4272f2.svg";